//
// Module for the Employer Reporting Create Batch wizard's Batch step
//
rs.module("employer/reporting/createbatch/batchstep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var createBatchOnlyCheckBox = stepContainer.js(jsSelectors.createBatchOnlyCheckBox, { required: false });

            // Get the wizard's next button 
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // Set title of Next button between "Next and "Finish" based on createBatchOnlyCheckBox
            createBatchOnlyCheckBox.change(function () {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on createBatchOnlyCheckBox
                if (createBatchOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);